var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 594,
    viewBox: "0 0 720 594",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M138.5 210L45.838 272.033C33.2134 280.485 33.4633 299.131 46.3099 307.241L217 415",
    stroke: "#219653",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.5 210L45.838 272.033C33.2134 280.485 33.4633 299.131 46.3099 307.241L217 415",
    stroke: "#219653",
    strokeDasharray: "2 8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M260.5 442.5L560.5 225.5",
    stroke: "#219653",
    strokeWidth: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260.5 442.5L560.5 225.5",
    stroke: "#219653",
    strokeDasharray: "2 8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M253.5 148L406.62 63.603C430.015 50.708 458.264 50.1773 482.127 62.1843L602 122.5",
    stroke: "#219653",
    strokeWidth: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M253.5 148L406.62 63.603C430.015 50.708 458.264 50.1773 482.127 62.1843L602 122.5",
    stroke: "#219653",
    strokeDasharray: "2 8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M171.644 425.134C181.23 419.622 196.77 419.622 206.356 425.134L301.811 480.021C311.396 485.532 311.396 494.468 301.811 499.979L159.356 589.866C149.77 595.378 134.23 595.378 124.644 589.866L29.1889 534.979C19.6037 529.468 19.6037 520.532 29.1889 515.021L171.644 425.134Z",
    fill: "url(#paint0_linear_54_28)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M406.598 274.671C416.381 269.518 431.911 270.094 441.286 275.956L529.343 328.86C538.718 334.723 538.387 343.653 528.604 348.805L382.918 433.356C373.136 438.509 357.606 437.934 348.231 432.071L260.173 379.167C250.799 373.305 251.13 364.375 260.912 359.222L406.598 274.671Z",
    fill: "url(#paint1_linear_54_28)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M570.644 152.134C580.23 146.622 595.77 146.622 605.356 152.134L700.811 207.021C710.396 212.532 710.396 221.468 700.811 226.979L558.356 316.866C548.77 322.378 533.23 322.378 523.644 316.866L428.189 261.979C418.604 256.468 418.604 247.532 428.189 242.021L570.644 152.134Z",
    fill: "url(#paint2_linear_54_28)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M149.644 127.134C159.23 121.622 174.77 121.622 184.356 127.134L279.811 182.021C289.396 187.532 289.396 196.468 279.811 201.979L137.356 291.866C127.77 297.378 112.23 297.378 102.644 291.866L7.1889 236.979C-2.3963 231.468 -2.3963 222.532 7.18891 217.021L149.644 127.134Z",
    fill: "url(#paint3_linear_54_28)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81 389H82.6957C81.03 391.874 83.4761 391.969 90.0339 394.196L182.062 425.451C192.521 429.003 209.479 429.003 219.938 425.451L311.966 394.196C318.524 391.969 320.97 391.874 319.304 389H321V486V486.5C321 490.119 318.366 493.239 313.583 496L218.32 551C208.755 556.523 193.245 556.523 183.679 551L88.4167 496C83.6338 493.239 81 489.619 81 486V389Z",
    fill: "url(#paint4_linear_54_28)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M480 116H481.696C480.03 118.874 482.476 118.969 489.034 121.196L581.062 152.451C591.521 156.003 608.479 156.003 618.938 152.451L710.966 121.196C717.524 118.969 719.97 118.874 718.304 116H720V213V213.5C720 217.119 717.366 220.239 712.583 223L617.32 278C607.755 283.523 592.245 283.523 582.679 278L487.417 223C482.634 220.239 480 216.619 480 213V116Z",
    fill: "url(#paint5_linear_54_28)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59 91H60.6957C59.03 93.8744 61.4761 93.9691 68.0339 96.1963L160.062 127.451C170.521 131.003 187.479 131.003 197.938 127.451L289.966 96.1963C296.524 93.9691 298.97 93.8744 297.304 91H299V188V188.5C299 192.119 296.366 195.239 291.583 198L196.32 253C186.755 258.523 171.245 258.523 161.679 253L66.4167 198C61.6338 195.239 59 191.619 59 188V91Z",
    fill: "url(#paint6_linear_54_28)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M183.644 324.134C193.23 318.622 208.77 318.622 218.356 324.134L313.811 379.021C323.396 384.532 323.396 393.468 313.811 398.979L218.356 453.866C208.77 459.378 193.23 459.378 183.644 453.866L88.1889 398.979C78.6037 393.468 78.6037 384.532 88.1889 379.021L183.644 324.134Z",
    fill: "#F1F1F1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M582.644 51.1336C592.23 45.6221 607.77 45.6221 617.356 51.1336L712.811 106.021C722.396 111.532 722.396 120.468 712.811 125.979L617.356 180.866C607.77 186.378 592.23 186.378 582.644 180.866L487.189 125.979C477.604 120.468 477.604 111.532 487.189 106.021L582.644 51.1336Z",
    fill: "#F1F1F1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M587.996 71.8756C594.626 68.0415 605.374 68.0415 612.004 71.8756L678.028 110.058C684.657 113.892 684.657 120.108 678.028 123.942L612.004 162.124C605.374 165.959 594.626 165.959 587.996 162.124L521.972 123.942C515.343 120.108 515.343 113.892 521.972 110.058L587.996 71.8756Z",
    fill: "#219653"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M188.996 343.876C195.626 340.041 206.374 340.041 213.004 343.876L279.028 382.058C285.657 385.892 285.657 392.108 279.028 395.942L213.004 434.124C206.374 437.959 195.626 437.959 188.996 434.124L122.972 395.942C116.343 392.108 116.343 385.892 122.972 382.058L188.996 343.876Z",
    fill: "#219653"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M612.004 71.8756C605.374 68.0415 594.626 68.0415 587.996 71.8756L521.972 110.058C516.617 113.155 515.588 117.806 518.883 121.5C519.668 120.62 520.697 119.795 521.972 119.058L587.996 80.8756C594.626 77.0415 605.374 77.0415 612.004 80.8756L678.028 119.058C679.303 119.795 680.332 120.62 681.117 121.5C684.412 117.805 683.383 113.155 678.028 110.058L612.004 71.8756Z",
    fill: "#DBDADA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.004 343.876C206.374 340.041 195.626 340.041 188.996 343.876L122.972 382.058C117.617 385.155 116.588 389.806 119.883 393.5C120.668 392.62 121.697 391.795 122.972 391.058L188.996 352.876C195.626 349.041 206.374 349.041 213.004 352.876L279.028 391.058C280.303 391.795 281.332 392.62 282.117 393.5C285.412 389.805 284.383 385.155 279.028 382.058L213.004 343.876Z",
    fill: "#DBDADA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M161.644 26.1336C171.23 20.6221 186.77 20.6221 196.356 26.1336L291.811 81.0205C301.396 86.532 301.396 95.4679 291.811 100.979L196.356 155.866C186.77 161.378 171.23 161.378 161.644 155.866L66.1889 100.979C56.6037 95.4679 56.6037 86.5321 66.1889 81.0206L161.644 26.1336Z",
    fill: "#F1F1F1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M166.996 45.8756C173.626 42.0415 184.374 42.0415 191.004 45.8756L257.028 84.0578C263.657 87.8919 263.657 94.1081 257.028 97.9422L191.004 136.124C184.374 139.959 173.626 139.959 166.996 136.124L100.972 97.9422C94.3426 94.1081 94.3426 87.8919 100.972 84.0578L166.996 45.8756Z",
    fill: "#219653"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.004 45.8756C184.374 42.0415 173.626 42.0415 166.996 45.8756L100.972 84.0578C95.6174 87.1546 94.5877 91.8055 97.8832 95.5C98.6677 94.6204 99.6975 93.7951 100.972 93.0578L166.996 54.8756C173.626 51.0415 184.374 51.0415 191.004 54.8756L257.028 93.0578C258.303 93.7951 259.332 94.6204 260.117 95.5C263.412 91.8055 262.383 87.1546 257.028 84.0578L191.004 45.8756Z",
    fill: "#DBDADA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M155.86 85.0783C158.337 83.6406 162.351 83.6406 164.827 85.0783L201.97 106.293C204.446 107.731 204.446 110.062 201.97 111.5L201.967 111.5C199.491 112.938 195.476 112.938 193 111.5L155.857 90.285C153.381 88.8472 153.381 86.5161 155.857 85.0783H155.86Z",
    fill: "#1C7C45"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M576.86 109.078C579.337 107.641 583.351 107.641 585.827 109.078L622.97 130.293C625.446 131.731 625.446 134.062 622.97 135.5L622.967 135.5C620.491 136.938 616.476 136.938 614 135.5L576.857 114.285C574.381 112.847 574.381 110.516 576.857 109.078H576.86Z",
    fill: "#1C7C45"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M175.86 381.078C178.337 379.641 182.351 379.641 184.827 381.078L221.97 402.293C224.446 403.731 224.446 406.062 221.97 407.5L221.967 407.5C219.491 408.938 215.476 408.938 213 407.5L175.857 386.285C173.381 384.847 173.381 382.516 175.857 381.078H175.86Z",
    fill: "#1C7C45"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.356 272.134C426.77 266.622 411.23 266.622 401.644 272.134L307.964 326H299V336H299.061C298.578 339.937 300.954 343.969 306.189 346.979L401.644 401.866C411.23 407.378 426.77 407.378 436.356 401.866L531.811 346.979C537.046 343.969 539.422 339.937 538.939 336H539V326H530.036L436.356 272.134Z",
    fill: "url(#paint7_linear_54_28)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M401.644 261.134C411.23 255.622 426.77 255.622 436.356 261.134L531.811 316.021C541.396 321.532 541.396 330.468 531.811 335.979L436.356 390.866C426.77 396.378 411.23 396.378 401.644 390.866L306.189 335.979C296.604 330.468 296.604 321.532 306.189 316.021L401.644 261.134Z",
    fill: "#219653"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M428.535 336.226C429.181 338.749 425.57 340.838 421.199 340.47L372.228 336.342C368.936 336.064 367.462 333.733 369.744 332.416L420.113 303.335L428.535 336.226Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M429.915 306.78L435.55 327.43L437.533 327.446L443.718 327.532C448.093 327.906 451.713 325.816 451.066 323.289L444.659 298.268L443.799 295.004C443.299 293.112 439.276 292.271 437.002 293.584L427.783 298.907L429.915 306.78Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.617 80.0169C208.114 76.1471 210.799 69.5722 210.799 60.7824C210.799 40.0386 195.846 14.8144 177.4 4.44254C167.554 -1.0933 158.704 -1.27923 152.591 2.90493L152 3.19274L147 6.50006L143 10.01L145.392 13.2415C144.486 16.1422 144 19.4818 144 23.2225C144 43.9662 158.954 69.1905 177.4 79.5623C184.851 83.752 191.732 84.8773 197.288 83.363L198.5 85L203.617 80.0169Z",
    fill: "url(#paint8_linear_54_28)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M204.799 66.1333C204.799 87.433 189.846 96.0665 171.4 85.4166C152.954 74.7667 138 48.8664 138 27.5666C138 6.26685 152.954 -2.36658 171.4 8.2833C189.846 18.9332 204.799 44.8335 204.799 66.1333Z",
    fill: "#F1F1F1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M201 63.9904C201 82.7575 187.792 90.3643 171.5 80.9808C155.208 71.5973 142 48.7767 142 30.0096C142 11.2425 155.208 3.63567 171.5 13.0192C187.792 22.4027 201 45.2233 201 63.9904Z",
    fill: "#E7E7E7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.315 74.0117C151.569 62.7466 144 46.2166 144 32.0096C144 13.2425 157.208 5.63567 173.5 15.0192C176.707 16.8661 179.794 19.2337 182.685 21.9884C179.235 18.3726 175.459 15.2992 171.5 13.0192C155.208 3.63567 142 11.2425 142 30.0096C142 45.0828 150.52 62.7709 162.315 74.0117Z",
    fill: "#DBDADA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.791 26.7486L170.553 27.534L170.553 54.3073L170.791 54.7155L181.673 53.652L170.791 26.7486Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.791 26.7484L159.909 41.0867L170.791 54.7155L170.791 41.7205L170.791 26.7484Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.791 57.0687L170.657 57.1778L170.657 66.7151L170.791 67.2393L181.679 56.0126L170.791 57.0687Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.791 67.2389L170.791 57.0683L159.909 43.4434L170.791 67.2389Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.791 54.7155L181.673 53.652L170.791 41.7207L170.791 54.7155Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.909 41.0868L170.791 54.7153L170.791 41.7205L159.909 41.0868Z",
    fill: "#393939"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.617 379.017C230.114 375.147 232.799 368.572 232.799 359.782C232.799 339.039 217.846 313.814 199.4 303.443C189.554 297.907 180.704 297.721 174.591 301.905L174 302.193L169 305.5L165 309.01L167.392 312.242C166.486 315.142 166 318.482 166 322.222C166 342.966 180.954 368.19 199.4 378.562C206.851 382.752 213.732 383.877 219.288 382.363L220.5 384L225.617 379.017Z",
    fill: "url(#paint9_linear_54_28)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M226.799 365.133C226.799 386.433 211.846 395.066 193.4 384.417C174.954 373.767 160 347.866 160 326.567C160 305.267 174.954 296.633 193.4 307.283C211.846 317.933 226.799 343.833 226.799 365.133Z",
    fill: "#FBA640"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M223 362.99C223 381.757 209.792 389.364 193.5 379.981C177.208 370.597 164 347.777 164 329.01C164 310.243 177.208 302.636 193.5 312.019C209.792 321.403 223 344.223 223 362.99Z",
    fill: "#F7931A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.315 373.012C173.569 361.747 166 345.217 166 331.01C166 312.243 179.208 304.636 195.5 314.019C198.707 315.866 201.794 318.234 204.685 320.988C201.235 317.373 197.459 314.299 193.5 312.019C177.208 302.636 164 310.243 164 329.01C164 344.083 172.52 361.771 184.315 373.012Z",
    fill: "#E18413"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M204.95 349.883C205.348 347.04 203.32 344.216 200.546 341.513L201.447 337.87L199.25 335.97L198.372 339.517C197.795 339.018 197.202 338.518 196.613 338.024L197.494 334.452L195.299 332.553L194.401 336.196L189.971 332.372L189.386 334.742C189.386 334.742 191.016 336.114 190.982 336.12C191.871 336.89 192.032 337.663 192.005 338.185L189.54 348.167C189.431 348.416 189.156 348.724 188.534 348.187C188.556 348.236 186.937 346.803 186.937 346.803L185.847 349.079L190.27 352.921L189.361 356.608L191.555 358.506L192.456 354.86C193.057 355.394 193.637 355.903 194.206 356.394L193.309 360.023L195.505 361.923L196.415 358.244C200.16 361.224 202.977 362.521 204.161 359.298C205.117 356.703 204.114 354.309 202.144 351.987C203.579 352.432 204.66 351.967 204.948 349.884L204.95 349.883ZM199.93 355.105C199.249 357.859 194.658 353.508 193.168 352.22L194.375 347.338C195.864 348.626 200.638 352.232 199.93 355.105L199.93 355.105ZM200.611 347.334C199.992 349.84 196.169 346.178 194.928 345.104L196.02 340.674C197.262 341.748 201.255 344.719 200.609 347.332",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M626.617 112.017C631.114 108.147 633.799 101.572 633.799 92.7824C633.799 72.0386 618.846 46.8144 600.4 36.4425C590.554 30.9067 581.704 30.7208 575.591 34.9049L575 35.1927L570 38.5001L566 42.01L568.392 45.2415C567.486 48.1422 567 51.4818 567 55.2225C567 75.9662 581.954 101.19 600.4 111.562C607.851 115.752 614.732 116.877 620.288 115.363L621.5 117L626.617 112.017Z",
    fill: "url(#paint10_linear_54_28)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M627.799 98.1333C627.799 119.433 612.846 128.066 594.4 117.417C575.954 106.767 561 80.8664 561 59.5666C561 38.2669 575.954 29.6334 594.4 40.2833C612.846 50.9332 627.799 76.8335 627.799 98.1333Z",
    fill: "#61C4A9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M624 95.9904C624 114.757 610.792 122.364 594.5 112.981C578.208 103.597 565 80.7767 565 62.0096C565 43.2425 578.208 35.6357 594.5 45.0192C610.792 54.4027 624 77.2233 624 95.9904Z",
    fill: "#50AF95"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M585.315 106.012C574.569 94.7466 567 78.2166 567 64.0096C567 45.2425 580.208 37.6357 596.5 47.0192C599.707 48.8661 602.794 51.2337 605.685 53.9884C602.235 50.3726 598.459 47.2992 594.5 45.0192C578.208 35.6357 565 43.2425 565 62.0096C565 77.0828 573.52 94.7709 585.315 106.012Z",
    fill: "#44A48A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597.655 81.5578C597.498 81.4807 596.686 81.0679 594.873 80.0214C593.431 79.1891 592.408 78.5478 592.049 78.3206C586.477 74.8188 582.318 71.2897 582.318 69.939C582.318 68.5883 586.477 69.8627 592.049 72.7897L592.049 77.1971C592.413 77.4379 593.456 78.1119 594.898 78.9443C596.628 79.9431 597.494 80.3594 597.65 80.4327L597.65 76.0269C603.21 79.5249 607.359 83.0487 607.359 84.3964C607.359 85.7441 603.211 84.4772 597.65 81.5532L597.655 81.5578ZM597.655 75.5741L597.655 71.6302L605.414 76.1098L605.414 70.0957L584.29 57.8993L584.29 63.9135L592.047 68.3923L592.047 72.3347C585.742 69.0311 581 67.7463 581 69.4873C581 71.2282 585.742 75.4173 592.047 79.3962L592.047 92.0343L597.654 95.2714L597.654 82.6287C603.945 85.9239 608.679 87.2058 608.679 85.4663C608.679 83.7269 603.949 79.5446 597.654 75.5718L597.655 75.5741Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_54_28",
    x1: 219.5,
    y1: 421,
    x2: 103.5,
    y2: 570.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_54_28",
    x1: 354.5,
    y1: 362.5,
    x2: 335.5,
    y2: 389.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_54_28",
    x1: 618.5,
    y1: 148,
    x2: 502.5,
    y2: 297.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_54_28",
    x1: 197.5,
    y1: 123,
    x2: 81.5,
    y2: 272.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_54_28",
    x1: 72.5,
    y1: 458.5,
    x2: 321,
    y2: 458.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.419404,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595068,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_54_28",
    x1: 471.5,
    y1: 185.5,
    x2: 720,
    y2: 185.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.419404,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595068,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_54_28",
    x1: 50.5,
    y1: 160.5,
    x2: 299,
    y2: 160.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.419404,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595068,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_54_28",
    x1: 290.5,
    y1: 325.728,
    x2: 539,
    y2: 325.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.419404,
    stopColor: "#1B7642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#229855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595068,
    stopColor: "#28A45D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_54_28",
    x1: 151.627,
    y1: 1.7319,
    x2: 191.004,
    y2: 86.2783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171828,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582542,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_54_28",
    x1: 173.627,
    y1: 300.732,
    x2: 213.004,
    y2: 385.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171828,
    stopColor: "#F1921F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582542,
    stopColor: "#FFB55C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_54_28",
    x1: 574.627,
    y1: 33.7319,
    x2: 614.004,
    y2: 118.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171828,
    stopColor: "#44A489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582542,
    stopColor: "#7CE9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50AF95"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.1378,
    height: 40.4998,
    fill: "white",
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 159.909 20.4658)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.d48ffb658f662caaba3f11294b52b6a9.svg";
export { ForwardRef as ReactComponent };